import { type ReactNode } from 'react';
import { messages } from '../i18n/messages.js';
import { useSession } from '../app/session-context.js';
import { BrandsPanel, CategoriesPanel } from './ReferenceScreen.js';

/**
 * Kategoriya va brend.
 *
 * Demodagi bitta menyu punkti ("Kategoriya va brend") — ikkalasi
 * BIRGA turadi, chunki tovar qo'shayotgan kontent menejer ularni bir
 * vaqtda tekshiradi: kategoriya bormi, brend bormi.
 *
 * Panellar `ReferenceScreen.tsx` da qoldi va shu yerdan chaqiriladi —
 * kod ko'chirilmadi, demak ikkilanmadi ham.
 */
export function CategoriesScreen(): ReactNode {
  const { locale } = useSession();
  const t = messages(locale);

  return (
    <section className="adm-page">
      <header className="adm-page__header">
        <h1 className="adm-page__title">{t.navCategories}</h1>
      </header>
      <CategoriesPanel />
      <BrandsPanel />
    </section>
  );
}
